import { useInstantSearch } from "react-instantsearch";
import { useEffect, useRef } from "react";

export const usePersistAlgoliaStateOnUnmount = () => {
  const { uiState, setUiState } = useInstantSearch();
  const uiStateRef = useRef(uiState);

  // TODO: if we call this hook from 6 dropdown everyone will restore the global UIState.
  // Maybe it could be better if each one tracks its own refinement?
  // const attributeValues = uiState.prod_cruise_en?.refinementList?.[attribute];

  // Keep up to date uiState in a reference
  useEffect(() => {
    // console.log("UPDATE REF", uiState);
    uiStateRef.current = uiState;
  }, [JSON.stringify(uiState)]);

  // Apply latest uiState to InstantSearch as the component is unmounted
  useEffect(() => {
    return () => {
      // console.log("UNMOUNT REF -> UISTATE");
      setTimeout(() => setUiState(uiStateRef.current));
    };
  }, [setUiState]);
};
